<template>
  <g>
    <defs>
      <path
        id="link@1x-a"
        d="M8.0756,10.8173 C8.3916,10.5023 8.9036,10.5023 9.2196,10.8173 C9.5356,11.1333 9.5356,11.6453 9.2196,11.9613 L9.2196,11.9613 L6.0946,15.0863 C5.7196,15.4593 5.5096,15.9673 5.5096,16.4953 C5.5096,17.0243 5.7196,17.5323 6.0946,17.9053 C6.8816,18.6643 8.1276,18.6643 8.9136,17.9053 L8.9136,17.9053 L12.0386,14.7803 C12.3546,14.4643 12.8666,14.4643 13.1826,14.7803 C13.4976,15.0963 13.4976,15.6083 13.1826,15.9243 L13.1826,15.9243 L10.0496,19.0493 C8.6256,20.3573 6.4236,20.3103 5.0566,18.9433 C3.6896,17.5763 3.6436,15.3743 4.9516,13.9503 L4.9516,13.9503 Z M13.3599,9.4972 C13.6749,9.1812 14.1869,9.1812 14.5029,9.4972 C14.8189,9.8132 14.8189,10.3252 14.5029,10.6402 L14.5029,10.6402 L10.5409,14.6032 C10.3889,14.7542 10.1829,14.8382 9.9689,14.8372175 C9.7549,14.8382 9.5489,14.7542 9.3969,14.6032 C9.2449,14.4522 9.1589,14.2462 9.1589,14.0312 C9.1589,13.8162 9.2449,13.6112 9.3969,13.4592 L9.3969,13.4592 Z M13.8508,5.0512 C15.2608,3.6492 17.5388,3.6492 18.9488,5.0512 C20.3508,6.4612 20.3508,8.7392 18.9488,10.1492 L18.9488,10.1492 L15.8238,13.2822 C15.6728,13.4352 15.4668,13.5202 15.2518,13.5202 C15.0378,13.5202 14.8318,13.4352 14.6798,13.2822 C14.5278,13.1312 14.4418,12.9252 14.4418,12.7102 C14.4418,12.4962 14.5278,12.2902 14.6798,12.1382 L14.6798,12.1382 L17.8048,9.0142 C18.1798,8.6402 18.3908,8.1332 18.3908,7.6042 C18.3908,7.0752 18.1798,6.5682 17.8048,6.1952 C17.0188,5.4362 15.7728,5.4362 14.9868,6.1952 L14.9868,6.1952 L11.8618,9.3202 C11.6568,9.5242 11.3598,9.6042 11.0798,9.5292 C10.8008,9.4542 10.5828,9.2362 10.5088,8.9572 C10.4338,8.6782 10.5138,8.3802 10.7178,8.1762 L10.7178,8.1762 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" xlink:href="#link@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>